export const CLIP_VARIANT_STATUS_VALUES = [
    'pending',
    'rendering',
    'ready',
    'approved',
    'rejected',
    'error',
];
//# sourceMappingURL=clip-variant.js.map